export default __webpack_public_path__ + "fc40e66d7b3ef8579a65dd474177476b.png";